import { render, staticRenderFns } from "./WebAuthn.vue?vue&type=template&id=12924e56"
import script from "./WebAuthn.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./WebAuthn.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports